import { useCallback } from 'react';
import { zoneStrippedDateString } from '../../../../utilities/DateHelpers';
import { de } from 'date-fns/locale';

// Custom hook for adding treatment
export function useFormatAndSendTreatmentRequest(accountId, treatmentRequest, refreshAccount) {
  const onAddTreatment = useCallback(async (data) => {
    if(data.effectiveDate) {
      data.effectiveDate = zoneStrippedDateString((data.effectiveDate as Date));
    }
    if(data.expiryDate) {
      data.expiryDate =  zoneStrippedDateString((data.expiryDate as Date));
    }

    if(!data.numberOfBillingPeriods?.length) { 
      delete data.numberOfBillingPeriods;
    }

    await treatmentRequest({accountId, treatmentId: data.treatmentId, accountTreatmentEffectiveDate: data.effectiveDate, accountTreatmentExpiryDate: data.expiryDate, expiresInNumberOfBillingPeriods: data.numberOfBillingPeriods});
    refreshAccount();
  }, [accountId, treatmentRequest, refreshAccount]);

  return onAddTreatment;
}
